import { httpsCallable } from "firebase/functions";
import { getStorage, ref, deleteObject } from "firebase/storage";
import { getFirebaseFunctions } from "../firebase";

interface Request {
  userId: string;
  factoringId: string;
  imageId: string;
}

export const deleteFactoringImage = async (
  userId: string,
  factoringId: string,
  imageId: string,
  filePath: string,
) => {
  const functions = getFirebaseFunctions();
  const storage = getStorage();

  const storageRef = ref(storage, filePath);
  await deleteObject(storageRef);

  const deleteFactoringImage = httpsCallable<Request, void>(
    functions,
    "admin_deleteFactoringImage",
  );

  await deleteFactoringImage({ userId, factoringId, imageId });
};
